import '../../../../EmitirFactura/Components/ResumenFactura/Styles/DocumentoTributario.css'
import TablaResumen from '../../../../EmitirFactura/Components/ResumenFactura/TablaResumen'
import {useSelector} from 'react-redux'
import {State} from '../../../../../reducers'
import { getLogoEmpresa } from '../../../../../actions/operaciones/operaciones.actions'
import {versionDteEmision} from '../../../../../utils/version-documento.utils'
import DetalleDistritoV2 from '../../CamposV2/DetalleDistritoV2'

const NotaCreditoDetalle = () => {
  const {formCliente, datosEmisor, datosFacturaRes, datosUUID} = useSelector((state: State) => state.facturacion)
  const {receptor} = useSelector((state: State) => state.historial.activeFactura.DetallesDTE)
  const {tipoDocumento, datosEmisor: datosEmisorCatalogo} = useSelector((state: State) => state.catalogos)
  const {activeDoc} = useSelector((state: State) => state.documentos);
  const datos = useSelector((state: State) => state.userLogin.datos)

  return (
    <>
      <div className='dt-center-content'>
        <h1 className='dt-title-h1'>Previsualización de Documento tributario electrónico</h1>
        <h1 className='dt-title-h1' style={{marginTop: '-16px'}}>{activeDoc.title}</h1>
        <div className='form-separator'></div>

        <div className='dt-card-grid-2c-1r' style={{alignItems: 'center'}}>
          <div className='dt-card-2c-1r-no-border' style={{textAlign: 'center'}}>
            <img src={getLogoEmpresa()} alt='Logo' className='logo-itprofis' />
          </div>

          <div className='dt-card-2c-1r'>
            <div className='dt-center-content'>
              <div className='dt-1r-c2'>
                <div className='detail'>
                  <label>Documento Tributario Electrónico Versión:</label>
                  <label>{versionDteEmision(activeDoc?.idDoc, datosEmisorCatalogo) || ''}</label>
                </div>
                {/* <div className='detail'>
                  <label>Periodo de Plazo:</label>
                  <label>0 días</label>
                </div> */}
                <div className='detail'>
                  <label>Código de Generación:</label>
                  <label>{datosUUID?.CodigoGeneracion || ''}</label>
                  {/* <label>12A8CFC6-612B-1EEE-83C8-AF4EEC3A4E29</label> */}
                </div>
                {/* <div className='detail'>
                  <label>Folio SAP:</label>
                  <label>131795704</label>
                </div> */}
                <div className='detail'>
                  <label>Moneda:</label>
                  <label>USD - Dólar estadounidense</label>
                </div>
                {/* <div className='detail'>
                  <label>Numero de Control:</label>
                  <label>DTE-03-00000001-000000000004584</label>
                </div> */}
              </div>
            </div>
          </div>
        </div>

        <div className='dt-card-grid-2c-1r'>
          <div className='dt-card-2c-1r'>
            <div className='dt-center-content'>
              <h2 className='dt-title-h2 '>Receptor</h2>
              <div className='dt-1r-c2'>
                <div className='detail'>
                  <label>Nombre o Razón Social:</label>
                  <label>{receptor.nombre ?? ''}</label>
                </div>
                <div className='detail'>
                  <label>Tipo de doc de identificación:</label>
                  <label>{tipoDocumento.find(docs => docs.codigo === receptor.tipoDocumento)?.valor ?? 'NIT'}</label>
                </div>
                <div className='detail'>
                  <label>No. doc de identificación:</label>
                  <label>{receptor.numDocumento ?? receptor.nit ?? ''}</label>
                </div>
                <div className='detail'>
                  <label>Correo electrónico:</label>
                  <label>{receptor.correo ?? ''}</label>
                </div>
                {/* <div className='detail'>
                  <label>Nombre comercial:</label>
                  <label>Nombre comercial</label>
                </div> */}
              </div>
            </div>
          </div>

          <div className='dt-card-2c-1r'>
            <div className='dt-center-content'>
              <h2 className='dt-title-h2 '>Emisor</h2>
              <div className='dt-1r-c2'>
                <div className='detail'>
                  <label>Nombre del Cliente</label>
                  <label>{datosEmisor?.nombre ?? ''}</label>
                </div>
                <div className='detail'>
                  <label>Dirección</label>
                  <label>{datosEmisor?.complemento ?? ''}</label>
                </div>
                <div className='detail'>
                  <label>Departamento</label>
                  <label>{datosEmisor?.departamento?.valor ?? ''}</label>
                </div>
                <div className='detail'>
                  <label>Municipio</label>
                  <label>{datosEmisor?.municipio?.valor ?? ''}</label>
                </div>
                <DetalleDistritoV2 etiqueta='Distrito:' usarEmisor />
                <div className='detail'>
                  <label>Giro</label>
                  <label>{datosEmisor?.descactividad ?? ''}</label>
                </div>
                <div className='detail'>
                  <label>NIT:</label>
                  <label>{datosEmisor?.nit ?? ''}</label>
                </div>
                <div className='detail'>
                  <label>Teléfono celular</label>
                  <label>{datosEmisor?.telefono ?? ''}</label>
                </div>
                <div className='detail'>
                  <label>NRC</label>
                  <label>{datosEmisor?.nrc ?? ''}</label>
                </div>
                <div className='detail'>
                  <label>Correo electrónico</label>
                  <label>{datosEmisor?.correo ?? ''}</label>
                </div>
                {/* <div className='detail'>
                  <label>Categoria</label>
                  <label>{datosEmisor?.categoria ?? ''}</label>
                </div>
                <div className='detail'>
                  <label>Solicitante</label>
                  <label>{datosEmisor?.solicitante ?? ''}</label>
                </div> */}
              </div>
            </div>
          </div>
        </div>

        <div className='dt-card w-100 text-center'>
          <TablaResumen />
        </div>

        <div className='dt-card w-100 text-center' style={{padding: 0}}>
          {!datosFacturaRes?.qr && (
            <div className='dt-card-grid-2c'>
              <div className='detail'>
                <label>Responsable por parte del Emisor:</label>
                <label>{datos?.name}</label>
              </div>
              <div className='detail'>
                <label>{datos?.tipo_documento || 'N° de Documento'}:</label>
                <label>{datos?.documento}</label>
              </div>
              <div className='detail'>
                <label>Responsable por parte del Receptor:</label>
                <label>{receptor.nombre}</label>
              </div>
              <div className='detail'>
                <label>N° de Documento:</label>
                <label>{receptor.numDocumento ?? receptor.nit}</label>
              </div>
            </div>
          )}

          {datosFacturaRes?.qr && (
            <div className='dt-card-grid-3c'>
              <div>
                <img src={datosFacturaRes.qr} alt='qr' className='dt-img-qr' />
              </div>
              <div className='dt-card-2c-responsive'>
                <div className='detail'>
                  <label>Responsable por parte del Emisor:</label>
                  <label>{datos?.name}</label>
                </div>
                <div className='detail'>
                  <label>Responsable por parte del Receptor:</label>
                  <label>{receptor.nombre}</label>
                </div>
              </div>
              <div className='dt-card-2c-responsive'>
                <div className='detail'>
                  <label>{datos?.tipo_documento || 'N° de Documento'}:</label>
                  <label>{datos?.documento}</label>
                </div>
                <div className='detail'>
                  <label>N° de Documento:</label>
                  <label>{receptor.numDocumento ?? receptor.nit ?? ''}</label>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default NotaCreditoDetalle
